var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.serviceAccountLink)?_c('nuxt-link',{attrs:{"to":_vm.serviceAccountLink}},[_vm._v(" "+_vm._s(_vm.typeDisplay)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.typeDisplay)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }